window.initDownloadable ?? (() => {
    window.initDownloadable = (section_id) => {

        const triggerKlaviyo = () => {
            const buttons = document.querySelectorAll(`section#shopify-section-${section_id} .careline-20-downloadable .button`);
            var _klOnsite = window._klOnsite || [];

            buttons.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    console.log(e);
                    let formId = e.currentTarget.dataset.id;
                    _klOnsite.push(['openForm', formId]);
                });
            });
        
        }

        triggerKlaviyo();

    }
})();